<template>
  <asc-dialog
    :show-dialog="showDialog"
    text="Export Fleet Reports"
    :on-close="handleClose"
    :on-primary="handleAccept"
    :primary-available="isCurrentDataValid"
    primary-button-text="Submit"
    full-width-buttons
    :width="500"
  >
    <template v-if="showDialog">
      <asc-report-export
        v-model="currentData"
        :report-types="reportTypes"
        :airlines="airlines"
        :tails="tails"
        :pwc-user="pwcUser"
      ></asc-report-export>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscReportExport from './AscReportExport'

export default {
  name: 'AscReportExportDialog',

  components: {
    AscDialog,
    AscReportExport,
  },

  mixins: [AscDialogMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    tails: {
      type: Array,
      default: () => [],
    },
    pwcUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentData: null,
    }
  },

  computed: {
    isCurrentDataValid() {
      if (!this.currentData) {
        return false
      }
      if (this.currentData) {
        if (!this.currentData.dates) {
          return false
        }
        if (
          !this.currentData.dates.endDate ||
          !this.currentData.dates.startDate
        ) {
          return false
        }
      }
      if (
        this.currentData.reportType === null ||
        this.currentData.reportType === ''
      ) {
        return false
      }
      return true
    },
  },

  watch: {
    data: {
      handler(newVal) {
        this.currentData = newVal
      },
    },
  },

  methods: {
    handleAccept() {
      this.onAccept(this.currentData)
      this.handleClose()
      this.currentData = null
    },
  },
}
</script>
